import { Fade } from '@material-ui/core';
import User from 'classes/User';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Preview from './Preview';
import StepOne from './StepOne';

import type { DispatchProp } from 'react-redux';

const START = 1,
  FORM = 2,
  FINAL = 3;

interface Props extends DispatchProp<any> {
  step: number;
  currentUser: any;
}

class Wizard extends Component<Props> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  componentDidUpdate(prevProps: Readonly<Props>): void {
    if (prevProps.step !== this.props.step) {
      const { step } = this.props;

      if (step === START) window.history.replaceState(null, null, '/producer/product/newproduct');
      if (step === FINAL) window.history.replaceState(null, null, '/producer/product/newproduct/preview');
    }
  }

  render() {
    const { step } = this.props;
    return (
      <>
        {step === START && (
          <Fade in timeout={500}>
            <StepOne />
          </Fade>
        )}
        {step === FORM && (
          <Fade in timeout={500}>
            <div>{this.props.children}</div>
          </Fade>
        )}
        {step === FINAL && <Preview />}
      </>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    step: state.components.newProductWizard.step,
    currentUser: new User(state.orbita.User.user),
  };
}

export default connect(mapStateToProps)(Wizard);
